var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreinfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C0.67 3 -1.01848e-07 2.33 -6.55671e-08 1.5C-2.92866e-08 0.67 0.67 -1.01848e-07 1.5 -6.55671e-08C2.33 -2.92866e-08 3 0.67 3 1.5C3 2.33 2.33 3 1.5 3ZM1.5 14C0.669999 14 -5.82673e-07 13.33 -5.46392e-07 12.5C-5.10112e-07 11.67 0.67 11 1.5 11C2.33 11 3 11.67 3 12.5C3 13.33 2.33 14 1.5 14ZM1.5 8.5C0.67 8.5 -3.4226e-07 7.83 -3.0598e-07 7C-2.69699e-07 6.17 0.67 5.5 1.5 5.5C2.33 5.5 3 6.17 3 7C3 7.83 2.33 8.5 1.5 8.5Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreinfo);
export default __webpack_public_path__ + "static/media/moreinfo.21b7f2b3a525effaa45af8bf3ab82f6a.svg";
export { ForwardRef as ReactComponent };